import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'btn-downloads-report',
  templateUrl: './btn-downloads-report.component.html',
  styleUrls: ['./btn-downloads-report.component.css']
})
export class BtnDownloadsReportComponent implements OnInit {
  @Input()
  public loading: boolean;

  @Output()
  public downloadXlsEvent: EventEmitter<any> = new EventEmitter();
  @Output()
  public downloadPdfEvent: EventEmitter<any> = new EventEmitter();
  

  constructor() { }

  ngOnInit(): void {
  }

  downloadXls(){
    this.downloadXlsEvent.emit();
  }

  downloadPdf(){
    this.downloadPdfEvent.emit();
  }

}
